import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface IsLocalIpResponse extends BackendResponse {
  result: boolean;
}

export interface IsLocalIpParameters extends NextApiParams {}

export const isLocalIp = withNextApi<IsLocalIpResponse, IsLocalIpParameters>(
  "/auth/IsLocalIp",
  { method: "GET" }
);
